import createCrud from '../../crud';

export default createCrud({
    resource: 'epics',
    parent: 'yodizuserstorydoc'
  });